import { CarrierCustomerAccountBinding, Locale, UserProfileCountry, Vendor } from "@shared/types";

import { CurrencyObject } from "@client-shared/lib/constants";
import {
  SetCountriesAction,
  SetCurrencyObjectAction,
  SetCurrentLocaleAction,
  SetCustomerAccountCarrierDetailsAction,
  SetErrorAction,
  SetInitializedAction,
  SetLoadingAction,
  SetRegionLocalesAction,
  SetVendorAction,
  VendorActions,
  vendorLocalStorageKeys,
  VendorState,
} from "./types";

export const DEFAULT_VENDOR_LOCALE = "en_US";

export const initialState: VendorState = {
  currentVendor: undefined,
  currentLocale: undefined,
  regionLocales: undefined,
  currencyObject: undefined,
  customerAccountCarrierDetails: undefined,
  countries: undefined,
  initialized: false,
  loading: false,
  error: undefined,
};

export function setVendor(vendor: Vendor | undefined): SetVendorAction {
  return {
    type: "SET_VENDOR",
    payload: {
      vendor,
    },
  };
}
export function setCurrencyObject(currencyObject: CurrencyObject | undefined): SetCurrencyObjectAction {
  return {
    type: "SET_CURRENCY_OBJECT",
    payload: {
      currencyObject,
    },
  };
}

export function setInitialized(initialized: boolean): SetInitializedAction {
  return {
    type: "SET_INITIALIZED",
    payload: {
      initialized,
    },
  };
}

export function setCurrentLocale(locale: Locale | undefined): SetCurrentLocaleAction {
  return {
    type: "SET_CURRENT_LOCALE",
    payload: {
      locale,
    },
  };
}

export function setRegionLocales(locales: Locale[] | undefined): SetRegionLocalesAction {
  return {
    type: "SET_REGION_LOCALES",
    payload: {
      locales,
    },
  };
}

export function setCustomerAccountCarrierDetails(
  customerAccountCarrierDetails?: CarrierCustomerAccountBinding[]
): SetCustomerAccountCarrierDetailsAction {
  return {
    type: "SET_CUSTOMER_ACCOUNT_CARRIER_DETAILS",
    payload: {
      customerAccountCarrierDetails,
    },
  };
}

export function setCountries(countries: UserProfileCountry[] | undefined): SetCountriesAction {
  return {
    type: "SET_COUNTRIES",
    payload: { countries },
  };
}

export function setLoading(loading: boolean): SetLoadingAction {
  return {
    type: "SET_LOADING",
    payload: { loading },
  };
}

export function setError(error: Error | undefined): SetErrorAction {
  return {
    type: "SET_ERROR",
    payload: { error },
  };
}

export function reducer(state: VendorState, action: VendorActions): VendorState {
  switch (action.type) {
    case "SET_INITIALIZED":
      return { ...state, initialized: true };
    case "SET_VENDOR":
      if (action.payload.vendor) {
        localStorage.setItem(vendorLocalStorageKeys.vendor, JSON.stringify(action.payload.vendor));
      } else {
        localStorage.removeItem(vendorLocalStorageKeys.vendor);
      }
      return { ...state, currentVendor: action.payload.vendor, initialized: true };
    case "SET_CURRENCY_OBJECT":
      return { ...state, currencyObject: action.payload.currencyObject };
    case "SET_CURRENT_LOCALE":
      if (action.payload.locale) {
        localStorage.setItem(vendorLocalStorageKeys.currentLocale, action.payload.locale);
      } else {
        localStorage.removeItem(vendorLocalStorageKeys.currentLocale);
      }
      return { ...state, currentLocale: action.payload.locale };
    case "SET_REGION_LOCALES":
      if (action.payload.locales) {
        localStorage.setItem(vendorLocalStorageKeys.regionLocales, JSON.stringify(action.payload.locales));
      } else {
        localStorage.removeItem(vendorLocalStorageKeys.regionLocales);
      }
      return { ...state, regionLocales: action.payload.locales };
    case "SET_CUSTOMER_ACCOUNT_CARRIER_DETAILS":
      if (action.payload.customerAccountCarrierDetails) {
        localStorage.setItem(
          vendorLocalStorageKeys.customerAccountCarrierDetails,
          JSON.stringify(action.payload.customerAccountCarrierDetails)
        );
      } else {
        localStorage.removeItem(vendorLocalStorageKeys.customerAccountCarrierDetails);
      }
      return { ...state, customerAccountCarrierDetails: action.payload.customerAccountCarrierDetails };
    case "SET_COUNTRIES":
      return { ...state, countries: action.payload.countries };
    case "SET_LOADING":
      return { ...state, loading: action.payload.loading };

    case "SET_ERROR":
      return { ...state, error: action.payload.error };
    default:
      return state;
  }
}
